export default {
    props: {
        showLoginAction: false
    },

    data() {
        return {
            Content: 'Welcome'
        }
    },

    methods: {
        onLoginActionClick() {
            window.location.href = '/Application/Dashboard';
        }
    }
}